import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { MenuState } from '../side-menu.types';

export const SideMenuStateActions = createActionGroup({
  source: 'SideMenuState',
  events: {
    'Get Menu State': emptyProps(),
    'Get Menu State Success': props<{ menuState: MenuState | null }>(),
    'Get Menu State Failure': props<{ error: string }>(),
    'Save Menu State': props<{ menuState: MenuState }>(),
    'Save Menu State Success': emptyProps(),
    'Save Menu State Failure': props<{ error: string }>(),
    'Set Horizontal Expanded': props<{ horizontalExpanded: boolean }>()
  }
});
